/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-void */
/* eslint-disable no-param-reassign */
import * as vp from 'vopay';
import { Button } from 'UI';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';

import styles from '../AccountingSystemOpen.module.scss';

import { PaymentUpdate } from '../types';

import { useClientData } from '../../../../../providers/ClientData.provider';
import {
  ExtraOptionsInfo,
  updateCustomerData,
  getAvailablePaymentMethodLabel,
  getAvailablePaymentMethodVisibility,
  getAvailablePaymentMethodsRenderOptions,
  getAvailablePaymentNew,
  seedElinxDefaults,
} from '../utils';

interface BankingUpdateDialogueProps {
  id: string;
  defaultValues: vp.TemporaryBillsOrInvoicesRails;
  type: 'Payable' | 'Receivable';
  paymentMethods: vp.SelectOption<ExtraOptionsInfo>[];
  appliedCreditNotes: string[];
  creditNotes: vp.CreditNote[];
  onSave: (savedValues: vp.TemporaryBillsOrInvoicesRails) => void;
  onUpdate: (
    updateType: 'Edit' | 'Add',
    savedValues: vp.TemporaryBillsOrInvoicesRails,
    bankingDefault: PaymentUpdate,
  ) => void;
}
type FC = FunctionComponent<BankingUpdateDialogueProps>;

const BulkItem: FC = ({
  onSave,
  defaultValues,
  id,
  type,
  paymentMethods,
  appliedCreditNotes,
  creditNotes,
  onUpdate,
}: BankingUpdateDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.BulkItem' });
  const { t: tUtils } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.Utils' });
  const { Box, Checkbox, Select, FilterableMultiSelector } = vp;

  const [showAccountUpdated, setShowAccountUpdate] = useState(false);
  const [showAccountAdded, setShowAccountAdded] = useState(false);
  const [creditNotesApplied, setCreditNotesApplied] = useState<vp.CreditNote[]>([]);
  const totalAmount =
    Number(vp.sanitizeToNumeric(String(defaultValues?.amountDue))) ||
    Number(vp.sanitizeToNumeric(String(defaultValues?.totalAmount))) ||
    0;
  const {
    response: { Country },
  } = useClientData();
  const bankingDefault: PaymentUpdate = {
    PaymentMethod: defaultValues?.paymentMethodUser || 'Bank Account',
    FinancialInstitutionNumber: defaultValues?.Customer?.BankAccount?.FinancialInstitutionNumber,
    BankTransitNumber: defaultValues?.Customer?.BankAccount?.BranchTransitNumber,
    AccountNumber: defaultValues?.Customer?.BankAccount?.AccountNumber,
    Email: defaultValues?.Customer?.Email || defaultValues?.Customer?.Interac?.EmailAddress,
    Phone: defaultValues?.Customer?.Phone || defaultValues?.Customer?.Interac?.PhoneNumber || '',
    Question: defaultValues?.Customer?.Interac?.Question,
    Answer: defaultValues?.Customer?.Interac?.Answer,
    PhoneNumber: defaultValues?.Customer?.BankAccount?.PhoneNumber,
    City: defaultValues?.Customer?.BankAccount?.City,
    Address: defaultValues?.Customer?.BankAccount?.Address,
    State: defaultValues?.Customer?.BankAccount?.State,
    ZipCode: defaultValues?.Customer?.BankAccount?.ZipCode,
    InteracMethod: defaultValues?.Customer?.Interac?.EmailAddress
      ? 'Email Address'
      : defaultValues?.Customer?.Interac?.PhoneNumber
      ? 'Phone Number'
      : 'Email Address',
    TokenDebit: defaultValues?.Customer?.DebitCard?.Token,
    TokenCredit: defaultValues?.Customer?.CreditCard?.Token,
    Language: defaultValues?.Customer?.Interac?.Language || 'en',
    ...seedElinxDefaults(defaultValues?.Customer),
  };

  useEffect(() => {
    if (showAccountUpdated) {
      setShowAccountUpdate(false);
    }
  }, [showAccountUpdated]);
  useEffect(() => {
    if (showAccountAdded) {
      setShowAccountAdded(false);
    }
  }, [showAccountAdded]);

  const SaveBank = (values: PaymentUpdate) => {
    const updatedData = updateCustomerData(
      values,
      defaultValues,
      Country,
      type,
      defaultValues.PaidAmount,
      '',
      creditNotesApplied.map((creditNote) => creditNote.id).join(','),
    );

    if (defaultValues.hasBankAccount) {
      setShowAccountUpdate(true);
    } else {
      setShowAccountAdded(true);
    }

    onSave(updatedData);
  };

  const clientName =
    defaultValues.Customer?.Name || defaultValues?.customerRef?.name || defaultValues?.vendorRef?.name || '';

  const creditNotesOptions = creditNotes.map((creditNote) => ({
    label: `${creditNote.currency} ${vp.formattedCurrency(String(creditNote.remainingCredit))}`,
    value: creditNote.id,
    isSelected: creditNotesApplied.includes(creditNote),
    isDisabled:
      !creditNotesApplied.map((credit) => credit.id).includes(creditNote.id) &&
      (creditNote.remainingCredit > Number(vp.sanitizeToNumeric(String(defaultValues.PaidAmount))) ||
        appliedCreditNotes.includes(creditNote.id)),
    ...creditNote,
  }));
  return (
    <div>
      <Formik initialValues={bankingDefault} onSubmit={SaveBank} enableReinitialize validateOnChange validateOnBlur>
        {() => (
          <div className={styles.bulkItem}>
            <Box flx="col">
              <Box ai="center" gapSize="12px" width="100%" flx="row">
                <Box gapSize="12px" ai="center" width="30%">
                  <Checkbox
                    name={`invoices-${id}`}
                    value={defaultValues.isSelected}
                    onBlur={() => {}}
                    onChange={() => {
                      onSave({ ...defaultValues, isSelected: !defaultValues.isSelected });
                    }}
                    size="sm"
                    variant="rounded"
                    hasNoPadding
                  />
                  <span className={styles.overflowEllipses}>{clientName} </span>
                </Box>
                {(paymentMethods.filter((payment) => payment.visible && payment.value !== 'new').length > 0 ||
                  defaultValues?.paymentMethodUser === 'eLinx') && (
                  <Box width="calc(70% - 15px)" gapSize="12px" flx="col">
                    <Select
                      version="2"
                      name="PaymentMethod"
                      options={paymentMethods.filter((option) => getAvailablePaymentMethodVisibility(option))}
                      renderSelectedValue={(option, { value }) =>
                        value === 'eLinx'
                          ? paymentMethods.find((method) => method.value === 'eLinx')?.renderedValue
                          : getAvailablePaymentMethodLabel(option)
                      }
                      renderOption={getAvailablePaymentMethodsRenderOptions}
                      optionValue={(option) => option.value}
                      renderDropdownHeader={({ close: closeDropdown }) =>
                        getAvailablePaymentNew(defaultValues, type, () => {
                          onUpdate('Add', defaultValues, bankingDefault);
                          closeDropdown();
                        }, tUtils)
                      }
                      style={{
                        '--triggerFontSize': '14px',
                        '--triggerBorderRadius': '4px',
                      }}
                      placeholder=""
                      value={defaultValues?.paymentMethodUser || ''}
                      onBlur={() => {}}
                      onChange={(event) => {
                        if (defaultValues) {
                          onSave({
                            ...defaultValues,
                            paymentMethodUser: event.target.value,
                            creditNotes: creditNotesApplied.join(','),
                            PaymentRail: vp.getPaymentRailsAccountingSoftware(event.target.value, Country, type),
                          });
                        }
                      }}
                    />
                    <FilterableMultiSelector
                      name="creditNotes"
                      items={creditNotesOptions as vp.SelectOption<{ isSelected: boolean } & vp.CreditNote>[]}
                      isNew={false}
                      position="fixed"
                      value={creditNotesOptions.filter((creditNote) => creditNote.isSelected)}
                      onSelect={(selectedCreditNotes) => {
                        setCreditNotesApplied(
                          creditNotes.filter((creditNote) =>
                            selectedCreditNotes
                              .map((selectedCreditNote) => selectedCreditNote.value)
                              .includes(creditNote.id),
                          ),
                        );
                        onSave({
                          ...defaultValues,
                          PaidAmount: String(
                            totalAmount -
                              creditNotes.reduce((acc, creditNote) => {
                                if (
                                  selectedCreditNotes
                                    .map((selectedCreditNote) => selectedCreditNote.value)
                                    .includes(creditNote.id)
                                ) {
                                  return acc + creditNote.remainingCredit;
                                }
                                return acc;
                              }, 0),
                          ),
                          creditNotes: selectedCreditNotes.map((creditNote) => creditNote.value).join(','),
                        });
                      }}
                      disabled={
                        creditNotes.length === 0 ||
                        creditNotes.every((creditNote) => creditNote.remainingCredit > totalAmount)
                      }
                      isDisabled={
                        creditNotes.length === 0 ||
                        creditNotes.every((creditNote) => creditNote.remainingCredit > totalAmount)
                      }
                      placeholder={t('applyCredits', { defaultValue: '---Apply Credits---' })}
                      disabledLabel={t('noCreditsAvailable', { defaultValue: 'No credits available' })}
                      variant="outline"
                      nosort
                    />
                  </Box>
                )}
                {paymentMethods.filter((payment) => payment.visible && payment.value !== 'new').length === 0 &&
                  defaultValues?.paymentMethodUser !== 'eLinx' && (
                  <Box width="calc(70% - 15px)">
                    <Button
                      id={`save-or-update-item-${id}`}
                      colorScheme={
                        defaultValues.hasBankAccount ||
                        defaultValues.hasCreditCard ||
                        defaultValues.hasDebitCard ||
                        defaultValues.hasInterac
                          ? 'secondary'
                          : 'primary'
                      }
                      size="small"
                      iconLeft="add"
                      disabled={!defaultValues.isSelected}
                      onClick={() => {
                        onUpdate('Add', defaultValues, bankingDefault);
                      }}
                    >
                      {t('paymentMethod', { defaultValue: 'Payment Method' })}
                    </Button>
                  </Box>
                )}
              </Box>
            </Box>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default BulkItem;
